import "core-js/modules/es6.object.assign";
import * as React from 'react';
import { GlobalBaseStyles } from '../../../theme/global/base';
import { GlobalDeprecatedStyles } from '../../../theme/global/global-deprecated-styles';
import { GlobalFlexboxGridStyles } from '../../../theme/global/flexboxgrid';
import { GlobalNormalizeStyles } from '../../../theme/global/normalize';
export var InnerGlobalStyles = React.memo(function InnerGlobalStyles(_props) {
  return React.createElement(React.Fragment, null, React.createElement(GlobalBaseStyles, null), React.createElement(GlobalFlexboxGridStyles, null), React.createElement(GlobalDeprecatedStyles, null), React.createElement(GlobalNormalizeStyles, null));
});
export var GlobalStyles = Object.assign(InnerGlobalStyles, {
  GlobalBaseStyles: GlobalBaseStyles,
  GlobalFlexboxGridStyles: GlobalFlexboxGridStyles,
  GlobalDeprecatedStyles: GlobalDeprecatedStyles,
  GlobalNormalizeStyles: GlobalNormalizeStyles
});